import styled from 'styled-components'

const SideBarContainer = styled.div`
  position: relative;
  grid-area: sidebar;
  align-content: start;
  width: 100%;

  h2 {
    font-family: 'Montserrat', Sans-serif;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 1px;
    text-align: center;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding-left: 0px;

    li {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      font-family: 'Montserrat', Sans-Serif;
      font-size: 16px;
      font-weight: 700;
      color: #4a4a4a;
      justify-content: center;
      i {
        font-size: 14px;
        padding-right: 8px;
      }
    }
  }
`

export default SideBarContainer



// WEBPACK FOOTER //
// ./src/components/containers/wizard/SideBarContainer.tsx